/**
 * @author
 * David Rivera (jherax)
 * https://github.com/jherax
 */

/* eslint no-console: 0 */

/**
 * Prints a message for deprecated methods and runs the new function.
 *
 * @param  {String} oldname: name of deprecated method
 * @param  {String} newname: name of the new method
 * @param  {Function} newFunc: reference to the new method
 * @return {Function}
 */
export default function deprecated(oldname, newname, newFunc) {
  const template = '"{0}" is deprecated, use: {1}';
  return (...args) => {
    const text = `${template.replace('{0}', oldname).replace('{1}', newname)}`;
    const style = 'color: red; display: block;';
    console.warn(`%c${text}`, style);
    return newFunc(...args);
  };
}
